<template>
  <div class="mt-4">
    <h1>
        Inventory
        <span v-if="count > 0">({{count}})</span>
    </h1>

    <load-and-error :loading="loading" :error="error" can-retry="true" @retry="refresh()"></load-and-error>

    <div v-if="!loading && !error">
        <form @submit.prevent="refresh()">
            <div class="form-group">
                <label for="search">Search</label>

                <div class="input-group">
                    <input type="text" class="form-control" id="search" v-model="search" />
                    <div class="input-group-append">
                        <barcode-scanner @scanned="refresh($event)" />
                    </div>
                </div>
            </div>

            <div class="row mb-4">
                <div class="col-6">
                    <button type="submit" class="btn btn-success w-100">Search</button>
                </div>
                <div class="col-6">
                    <button class="btn btn-outline-success w-100" @click="clearSearch">Clear</button>
                </div>
            </div>
        </form>

        <table class="table table-stripped" v-if="inventory.length > 0">
            <thead>
                <tr>
                    <th class="clickable" @click="toggleSort('part_number')">
                        Part Number

                        <i class="fa fa-caret-down" v-if="sort == 'part_number'"></i>
                        <i class="fa fa-caret-up" v-if="sort == '-part_number'"></i>
                    </th>
                    <th class="clickable" @click="toggleSort('name')">
                        Part

                        <i class="fa fa-caret-down" v-if="sort == 'name'"></i>
                        <i class="fa fa-caret-up" v-if="sort == '-name'"></i>
                    </th>
                    <th v-for="(display, location) in LOCATIONS" :key="location" class="clickable" @click="toggleSort(`stock:${location}`)">
                        {{display}}

                        <i class="fa fa-caret-down" v-if="sort == `stock:${location}`"></i>
                        <i class="fa fa-caret-up" v-if="sort == `-stock:${location}`"></i>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="part in inventory" :key="part.id">
                    <td>
                        <router-link :to="{name: 'part', params: {id: part.id}}">
                            {{part.part_number}}
                        </router-link>
                    </td>
                    <td>
                        <router-link :to="{name: 'part', params: {id: part.id}}">
                            {{part.name}}
                        </router-link>
                    </td>
                    <td v-for="(display, location) in LOCATIONS" :key="location">{{part.stock[display]}}</td>
                </tr>
            </tbody>
        </table>

        <h2 v-if="inventory.length == 0">No results</h2>
        <nav v-if="pageCount > 1">
            <ul class="pagination justify-content-center">
                <li class="page-item text-success" :class="{disabled: page <= 0}">
                    <a class="page-link" @click="previousPage()">
                        <i class="fa fa-chevron-left"></i>
                    </a>
                </li>
                <li class="page-item disabled" aria-current="page">
                    <a class="page-link">{{page + 1}} of {{pageCount}}</a>
                </li>
                <li class="page-item text-success" :class="{disabled: page + 1 >= pageCount}">
                    <a class="page-link" @click="nextPage()">
                        <i class="fa fa-chevron-right"></i>
                    </a>
                </li>
            </ul>
        </nav>
    </div>
  </div>
</template>

<script>
import api from 'ays-shared/api';
import utils from 'ays-shared/utils';
import constants from '@/constants';

export default {
  name: 'List',
  data() {
    return {
      loading: false,
      error: '',
      inventory: [],
      search: '',
      page: 0,
      pageCount: 1,
      count: 0,
      sort: 'name',
      LOCATIONS: constants.LOCATIONS,
    };
  },
  mounted() {
    this.refresh();
  },
  methods: {
    clearSearch() {
      this.search = '';
      this.refresh();
    },
    async refresh(search) {
      this.search = search || this.search;

      this.error = '';
      this.loading = true;

      try {
        const res = await api.inventory.find(this.search, this.page, this.sort);
        this.pageCount = Math.ceil(res.count / api.LIMIT);
        this.count = res.count;
        this.inventory = res.results;
      }
      catch (err) {
        this.inventory = [];
        this.error = utils.errorMessage(err);
        utils.captureException(err, 'List');
      }
      finally {
        this.loading = false;
      }
    },
    previousPage() {
      if (this.page > 0) {
        this.page--;
        this.refresh();
      }
    },
    nextPage() {
      if (this.page < this.pageCount) {
        this.page++;
        this.refresh();
      }
    },
    toggleSort(sort) {
      if (this.sort == sort) {
        this.sort = `-${sort}`;
      }
      else {
        this.sort = sort;
      }

      this.refresh();
    },
  },
};
</script>
